﻿import { HttpTransportType, HubConnection, HubConnectionBuilder, RetryContext } from '@microsoft/signalr'
import { environment } from '@/config/environment'
import { fetchAccessToken } from './AuthConfig'

export function connectionHub(): HubConnection {
    return new HubConnectionBuilder()
        .withUrl(`${environment.BACKEND_URL}/realtime`, {
            transport: HttpTransportType.WebSockets,
            skipNegotiation: true,
            accessTokenFactory(): string | Promise<string> {
                return fetchAccessToken(environment.BACKEND_API_SCOPE)
            },
        })
        .withAutomaticReconnect({
            nextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {
                if (retryContext.previousRetryCount == 3) {
                    // Display error-banner
                }
                return Math.min(retryContext.previousRetryCount * 1000, 5000)
            },
        })
        .build()
}
